'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;
// import { localStore } from 'utils/localStorage';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _voucher = require('redux/modules/voucher');

var vouchersAction = _interopRequireWildcard(_voucher);

var _reactRouterRedux = require('react-router-redux');

var _lodash = require('lodash');

var _support = require('helpers/support');

var _PCard = require('../Common/PCard');

var _PCard2 = _interopRequireDefault(_PCard);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { Tabs, Tab } from 'react-bootstrap';
var ManagePromotion = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    couponsJoined: state.voucher.couponsJoined,
    codesJoined: state.voucher.codesJoined,
    user: state.auth.user
  };
}, (0, _extends3.default)({}, vouchersAction, { push: _reactRouterRedux.push })), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(ManagePromotion, _Component);

  function ManagePromotion() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ManagePromotion);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ManagePromotion.__proto__ || (0, _getPrototypeOf2.default)(ManagePromotion)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      tab: 'general',
      lists: [],
      general: _this.props.couponsJoined || [],
      partner: _this.props.codesJoined || []
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ManagePromotion, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.getCouponsByUser();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!(0, _lodash.isEqual)(this.props.couponsJoined, nextProps.couponsJoined) || !(0, _lodash.isEqual)(this.props.codesJoined, nextProps.codesJoined)) {
        if (this.state.tab === 'general') {
          this.setState({ lists: nextProps.couponsJoined });
        } else if (this.state.tab === 'partner') {
          this.setState({ lists: nextProps.codesJoined });
        }
      }
    }
  }, {
    key: 'isUsed',
    value: function isUsed(v) {
      if ((0, _lodash.isEmpty)(this.props.user)) return false;
      return v && v.usersUsed && v.usersUsed.indexOf(this.props.user._id) !== -1;
    }
  }, {
    key: 'changeTab',
    value: function changeTab(tab) {
      var _props = this.props,
          couponsJoined = _props.couponsJoined,
          codesJoined = _props.codesJoined;

      switch (tab) {
        case 'general':
          this.setState({ tab: tab, lists: couponsJoined });
          break;
        case 'partner':
          this.setState({ tab: tab, lists: codesJoined });
          break;
        default:
          break;
      }
    }
  }, {
    key: 'changeCodeEnterprise',
    value: function changeCodeEnterprise(campaign, detailPartner) {
      var setPartnerDetail = this.props.setPartnerDetail;

      setPartnerDetail(detailPartner);
    }
  }, {
    key: 'renderList',
    value: function renderList() {
      var _this2 = this;

      var styles = require('./ManagePromotion.scss');
      var _state = this.state,
          lists = _state.lists,
          tab = _state.tab;

      return _react2.default.createElement(
        'div',
        { className: styles.vSection },
        _react2.default.createElement(
          'div',
          { className: styles.lists },
          lists && lists.length ? lists.map(function (v, i) {
            if (tab === 'general') {
              return _react2.default.createElement(_PCard2.default, {
                history: _this2.props.history,
                key: 'genCard_' + i,
                className: styles.PCard,
                card: (0, _support.promoData)(v)
              });
            }
            if (tab === 'partner') {
              return _react2.default.createElement(_PCard2.default, {
                history: _this2.props.history,
                key: 'parCard_' + i,
                className: styles.PCard,
                card: (0, _support.promoData)(v),
                onClick: function onClick(card) {
                  return _this2.changeCodeEnterprise(card, v);
                }
              });
            }
          }) : _react2.default.createElement(
            'div',
            { className: styles.nodata },
            'Kh\xF4ng c\xF3 d\u1EEF li\u1EC7u'
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      //
      var styles = require('./ManagePromotion.scss');
      var tab = this.state.tab;

      return _react2.default.createElement(
        'div',
        { className: styles.voucher },
        _react2.default.createElement(
          'div',
          { className: styles.tabs },
          _react2.default.createElement(
            'div',
            {
              className: styles.tab + ' ' + (tab === 'general' ? styles.active : ''),
              onClick: function onClick() {
                return _this3.changeTab('general');
              }
            },
            _react2.default.createElement('i', { className: 'fa fa-gift' }),
            ' \u01AFu \u0111\xE3i chung'
          ),
          _react2.default.createElement(
            'div',
            {
              className: styles.tab + ' ' + (tab === 'partner' ? styles.active : ''),
              onClick: function onClick() {
                return _this3.changeTab('partner');
              }
            },
            _react2.default.createElement('i', { className: 'fa fa-users' }),
            ' \u01AFu \u0111\xE3i \u0111\u1ED1i t\xE1c'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.tabContent },
          this.renderList()
        )
      );
    }
  }]);
  return ManagePromotion;
}(_react.Component), _class2.propTypes = {
  // @data
  user: _react.PropTypes.object,
  couponsJoined: _react.PropTypes.array,
  codesJoined: _react.PropTypes.array,
  history: _react.PropTypes.object,
  // @action
  getCouponsByUser: _react.PropTypes.func,
  setPartnerDetail: _react.PropTypes.func
}, _temp2)) || _class);
exports.default = ManagePromotion;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/ManagePromotion/ManagePromotion.js
// module id = 1611
// module chunks = 0